import React, { useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import { Form, Formik } from "formik";
import { gamificationSchema } from '../../../../models/gamification/gamificationSchema';
import { gamificationDefaults } from '../../../../models/gamification/gamificationDefaults';
import GamificationAttendancePoints from "./GamificationAttendancePoints";
import GamificationAttendanceMilestones from "./GamificationAttendanceMilestones";
import GamificationLevelRanks from './GamificationLevelRanks';
import GamificationGraduation from "./GamificationGraduation";
import { LoadingButton } from '../../../../components/Common';

const TABS = [
    { id: '1', icon: 'mdi-calendar-check-outline', label: 'Frequência' },
    { id: '2', icon: 'mdi-medal-outline', label: 'Graduação' },
    { id: '3', icon: 'mdi-crown-outline', label: 'Ranking' },
];

const GamificationForm = ({ initialData, onSave, isSaving }) => {
    const [activeTab, setActiveTab] = useState('1');
    const formValues = { 
        ...gamificationDefaults, 
        ...initialData,
        achievements: initialData?.achievements?.length > 0 ? initialData.achievements : gamificationDefaults.achievements,
        levelRanks: initialData?.levelRanks?.length > 0 ? initialData.levelRanks : gamificationDefaults.levelRanks
    };

    return (
        <Formik
            enableReinitialize
            initialValues={formValues}
            validationSchema={gamificationSchema}
            onSubmit={(values, { setSubmitting }) => {
                onSave(values);
                setSubmitting(false);
            }}
        >
            {({ isSubmitting, isValid, submitCount, values, setFieldValue }) => (
                <Form>
                    {/* Top Navigation Bar - compact horizontal tabs */}
                    <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
                        <Nav className="nav-pills gap-1 flex-nowrap overflow-auto flex-grow-1" style={{ scrollbarWidth: 'none' }}>
                            {TABS.map(tab => (
                                <NavItem key={tab.id}>
                                    <NavLink
                                        className={classnames(
                                            'rounded-0 px-3 py-2 d-flex align-items-center gap-2 border-0 font-size-13',
                                            { 'active': activeTab === tab.id }
                                        )}
                                        onClick={() => setActiveTab(tab.id)}
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: activeTab === tab.id ? 'var(--bs-primary)' : '#f0f2f5',
                                            color: activeTab === tab.id ? '#fff' : '#495057',
                                            whiteSpace: 'nowrap',
                                            transition: 'all 0.15s ease'
                                        }}
                                    >
                                        <i className={`mdi ${tab.icon} font-size-16`}></i>
                                        <span className="fw-semibold">{tab.label}</span>
                                    </NavLink>
                                </NavItem>
                            ))}
                        </Nav>
                        <LoadingButton 
                            type="submit" 
                            color="primary" 
                            className="rounded-0 px-4 fw-bold flex-shrink-0" 
                            style={{ minWidth: '140px' }}
                            loading={isSaving || isSubmitting}
                            loadingText="Salvando..."
                        >
                            Salvar
                        </LoadingButton>
                    </div>

                    {submitCount > 0 && !isValid && (
                        <div className="alert alert-danger border-0 rounded-0 py-2 px-3 d-flex align-items-center mb-4 font-size-13">
                            <i className="mdi mdi-alert-circle me-2 font-size-16"></i>
                            Existem campos obrigatórios com erros. Verifique as abas.
                        </div>
                    )}

                    <div className="bg-white rounded-0 p-4 border-top">
                    <TabContent activeTab={activeTab}>
                        {/* TAB 1 - Frequência */}
                        <TabPane tabId="1">
                            <GamificationAttendancePoints values={values} setFieldValue={setFieldValue} />
                            <GamificationAttendanceMilestones values={values} setFieldValue={setFieldValue} />
                        </TabPane>

                        {/* TAB 2 - Graduação */}
                        <TabPane tabId="2">
                            <GamificationGraduation values={values} setFieldValue={setFieldValue} />
                        </TabPane>

                        {/* TAB 3 - Ranking de Níveis */}
                        <TabPane tabId="3">
                            <GamificationLevelRanks values={values} setFieldValue={setFieldValue} />
                        </TabPane>
                    </TabContent>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default GamificationForm;
